/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Collaborators_Invitecollaboratorassignment2Inputs */

const en_settings_collaborators_invitecollaboratorassignment2 = /** @type {(inputs: Settings_Collaborators_Invitecollaboratorassignment2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assignment`)
};

/**
* | output |
* | --- |
* | "Assignment" |
*
* @param {Settings_Collaborators_Invitecollaboratorassignment2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_collaborators_invitecollaboratorassignment2 = /** @type {((inputs?: Settings_Collaborators_Invitecollaboratorassignment2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Collaborators_Invitecollaboratorassignment2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_collaborators_invitecollaboratorassignment2(inputs)
});
export { settings_collaborators_invitecollaboratorassignment2 as "settings_collaborators_inviteCollaboratorAssignment" }